import { 
    IMutations,
    IMutationsCommunicationPayload
} from './mutations.types'
import { ICommunication, INotification, ICommunicationData, ICommunicationReport } from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants'
import { Utilities as _appUtils } from '@/shared/utilities'

export const mutations: IMutations = {
    
    /** refresh the state with application header info */
    setCommunication(state: ICommunicationData, payload: IMutationsCommunicationPayload): void {
        
        state.grantInfo = this.$services.grant.formatGrantInfo(payload.comm.Grants);
        state.communication = payload.comm.GrantCommunication;

        if(payload.comm.GrantCommunication && payload.comm.GrantCommunication.WorkflowData) {
            state.workflowData = _appUtils.parseJSON(payload.comm.GrantCommunication.WorkflowData)
            state.currentStepId = state.workflowData.CurrentStepId
        }

        if(payload.comm.GrantCommunication) {
            state.communication.Steps = _appUtils.parseJSON(payload.comm.GrantCommunication.Steps || '{}')
        }

        state.selectedSteps = JSON.parse(payload.comm.Steps) || [];
        
        state.reports = payload.comm.CommunicationReports
        .filter(x => (x && x.StepId))
        .map(x => {
            x.ReportData = _appUtils.parseJSON(x.ReportData);                
            return x;
        });

        if(state.reports.length > 0) {
            state.selectedKey = state.reports[0].StepId;
        }

        state.template = payload.comm.Template;

        state.guidelineDoc = payload.comm.GuidelineDocument;

        state.workflowInfo = payload.comm.WorkflowJourney;

        state.workflowSteps = payload.comm.WorkflowSteps;
    },

    /** set the report data */
    setReportData(state: ICommunicationData,payload: ICommunicationReport) {
        var report = state.reports.find(x => x.CommunicationReportId == payload.CommunicationReportId);
        report.ReportData = _appUtils.parseJSON(payload.ReportData);
    },

    /** set the communication data */
    setCommunicationData(state: ICommunicationData, payload: IMutationsCommunicationPayload): void {
        if(payload.comm.GrantCommunication && payload.comm.GrantCommunication.WorkflowData) {
            state.workflowData = _appUtils.parseJSON(payload.comm.GrantCommunication.WorkflowData)
            state.currentStepId = state.workflowData.CurrentStepId
        }

        if(payload.comm.GrantCommunication) {
            state.communication.Steps = _appUtils.parseJSON(payload.comm.GrantCommunication.Steps || '{}')
        }

        state.reports = payload.comm.CommunicationReports
        .filter(x => (x && x.StepId))
        .map(x => {
            x.ReportData = _appUtils.parseJSON(x.ReportData);                
            return x;
        });
        state.workflowInfo = payload.comm.WorkflowJourney;
    }

}